import { render } from "./AccountStatment.vue?vue&type=template&id=36d5b3c2&scoped=true"
import script from "./AccountStatment.vue?vue&type=script&lang=js"
export * from "./AccountStatment.vue?vue&type=script&lang=js"

import "./AccountStatment.vue?vue&type=style&index=0&id=36d5b3c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d5b3c2"]])

export default __exports__